const isValidValue = (value) => {
    return value !== null && value !== undefined;
};

const isEmpty = (value) => {
    const isInvalid = !isValidValue(value);
    const isEmptyString = typeof value === 'string' && value.trim() === '';
    const isEmptyArray = Array.isArray(value) && value.length === 0;
    const isEmptyObject = typeof value === 'object' && value !== null && Object.keys(value).length === 0;

    return isInvalid || isEmptyString || isEmptyArray || isEmptyObject;
};

const parseToNumber = (value) => {
    const num = Number(value);

    return Number.isFinite(num) ? num : undefined;
};

const safeJsonParse = (value) => {
    if (!isValidValue(value)) return null;

    if (typeof value === 'object') return value;

    try {
        return JSON.parse(value);
    } catch {
        return null;
    }
};

const valueUtils = {
    isEmpty,
    isValidValue,
    parseToNumber,
    safeJsonParse,
};

export default valueUtils;
